import { useLogoutMutation } from '@/api/api.slice.tsx';
import { useAppDispatch } from '@/app/hooks.ts';
import { ACTION_LOGOUT } from '@/app/store.ts';
import { startTour } from '@/features/Tutorial/Tutorial.slice.ts';
import { availableLocales } from '@/i18n/i18n.ts';
import {
  ButtonWithMenu,
  getCurrentReadableLocaleShortName,
  isLocale,
} from '@arsnovasystems/ars-front-lib';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import HelpIcon from '@mui/icons-material/Help';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { Box, Button, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

/**
 * Top menu bar
 *
 * @returns the AppTools component
 */
export default function AppTools() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  const [logoutTrigger] = useLogoutMutation();
  const dispatch = useAppDispatch();

  const handleOnLogout = async () => {
    await logoutTrigger();
    // reload the page to the base url
    void navigate('/login');
    dispatch(ACTION_LOGOUT());
  };

  const handleOnMyAccount = () => {
    void navigate('/partner-info');
  };

  return (
    <Stack
      direction={'row'}
      sx={{ mr: 2 }}
    >
      <Button
        onClick={() => {
          if (isLocale(i18n.language)) {
            const languageIdx = availableLocales.indexOf(i18n.language);
            const nextLanguageIdx = (languageIdx + 1) % availableLocales.length;
            const nextLanguage = availableLocales[nextLanguageIdx];

            void i18n.changeLanguage(nextLanguage);
          }
        }}
      >
        {getCurrentReadableLocaleShortName()}
      </Button>

      <Box data-tour-selector='help-menu-button'>
        <IconButton
          sx={(theme) => ({
            svg: {
              fontSize: '30px',
              color: theme.palette.neutral.main,
            },
          })}
          onClick={() => {
            dispatch(startTour());
          }}
        >
          <HelpIcon />
        </IconButton>
      </Box>

      <ButtonWithMenu
        Icon={
          <AccountCircleRoundedIcon
            sx={(theme) => ({
              fontSize: '30px',
              color: theme.palette.neutral.main,
            })}
          />
        }
        actions={[
          {
            label: t('ik.my.account'),
            onClick: handleOnMyAccount,
            Icon: AccountCircleRoundedIcon,
          },
          {
            label: t('ik.logout'),
            onClick: handleOnLogout,
            Icon: LogoutRoundedIcon,
          },
        ]}
      />
    </Stack>
  );
}
